<mat-form-field class="field" [formGroup]="group" appearance="outline">
  <mat-label>{{ config.label }}</mat-label>
  <input
    matInput
    [ngxMatDatetimePicker]="picker"
    placeholder="{{ config.placeholder || config.label }}"
    [formControlName]="config.name" />
  <mat-datepicker-toggle matSuffix [for]="$any(picker)">
  </mat-datepicker-toggle>
  <ngx-mat-datetime-picker #picker [showSpinners]="true">
  </ngx-mat-datetime-picker>
</mat-form-field>
